import { render, staticRenderFns } from "./MContributionPost.vue?vue&type=template&id=51332410&scoped=true&"
import script from "./MContributionPost.vue?vue&type=script&lang=js&"
export * from "./MContributionPost.vue?vue&type=script&lang=js&"
import style0 from "./MContributionPost.vue?vue&type=style&index=0&id=51332410&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51332410",
  null
  
)

export default component.exports